import '@/app/styles/app.css'
import '@/app/styles/forms.css'

import Prism from 'prismjs'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { AppRouter } from '@/app/router'

// This prevents runtime errors like "Prism is not defined" in production
// https://github.com/facebook/lexical/issues/6575#issuecomment-2676178503
if (typeof globalThis.Prism === 'undefined') {
  globalThis.Prism = Prism
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
)
